import {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import actionsService from '../../../services/actionsService'

interface RedirectProps {
  id: string;
}

function Redirect({id}: Readonly<RedirectProps>) {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (id) {
      actionsService.qr.get(id)
        .then(res => {
          const relativePath = `/${res.additionalInfo}`
          navigate(relativePath)
        })
        .catch(err => {
          setError(`Failed to process QR code. Please try again. ${err}`)
          setIsLoading(false)
        })
    } else {
      setError('No ID provided')
      setIsLoading(false)
    }
  }, [id, navigate])

  if (error) {
    return (
      <div style={{padding: '20px', textAlign: 'center'}}>
        <p style={{color: 'red'}}>{error}</p>
        <button type="button" onClick={() => window.location.reload()}>
          Try Again
        </button>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div style={{padding: '20px', textAlign: 'center'}}>
        <div>{`Redirecting with ID: ${id}...`}</div>
        <div style={{marginTop: '10px'}}>
          <small>If redirect does not work automatically, please refresh the page.</small>
        </div>
      </div>
    )
  }

  return null
}

export default Redirect
